const orderStatysQuery = `
  query OrderStatus($orderId: UUID!) {
    orderStatus(orderId: $orderId) {
      orderId
      status
      underwritingResultStatus
      errors {
        message
        code
      }
    }
  }
`;

export default orderStatysQuery;
